<template>
	<GBRightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<GBModalVScrollable class="member-list"
			title="メンバー"
			header_height="115"
			bottom_height="0"
			v-on:close="onClose"
			ref="content"
		>
			<template v-slot:header>
				<v-layout row class="modal-header-filter">
					<v-btn v-if="isEditable" fab flat absolute class="pa-0 ma-0 add-member white--text" v-on:click="onClickAdd">追加</v-btn>
					<v-flex xs10 class="mx-2">
						<v-text-field dark clearable height="23" v-model="filter_name" placeholder="名前で検索" color="white" single-line></v-text-field>
					</v-flex>
					<v-flex xs2 class="mx-2">
						<v-btn dark icon
							v-if="isFiltering"
							color="orange" 
							v-on:click="onClickFiltering">
							<v-icon>filter_list</v-icon>
						</v-btn>
						<v-btn flat icon blue 
							v-else
							color="white" 
							v-on:click="onClickFiltering">
							<v-icon>filter_list</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
			</template>
			<GBMemberListRowOuter
				v-for="item in filtered_members"
				v-bind:key="item.member.codeWithType"
				v-bind:item=item.member
				v-bind:alert=item.alert
				v-bind:isEditable="isEditable"
				v-bind:watchSlide="watchSlide"
				v-bind:isSelected="selected_member != null && selected_member.member===item.member"
				v-bind:isSpliced="
					selected_member != null && 
					selected_member.member.code===item.member.code && 
					selected_member.status === move_state.MOVE_END"
				v-bind:PositionFirst="item.member.code===filtered_members[0].member.code" 
				v-bind:isRowMove="selected_member!=null && event_target!=null"
				v-bind:isSelectedBeforeItem="selected_member != null && 
					filtered_members.findIndex((m) => m.member === selected_member.member) -1 >= 0 && 
					item.member === filtered_members[filtered_members.findIndex((m) => m.member === selected_member.member) -1].member"
				v-on:schedule-list-row-slide="onScheduleListRowSlide"
				v-on:show-member-info="onClickShowMemberInfo"
				v-on:member-row-move-start="memberRowMoveStart"
				v-on:member-row-move-end="memberRowMoveEnd"
				v-on:insert-member-row="InsertMemberRow"
				v-on:insert-member-row-top="InsertMemberRowTop"
				ref="rows"
			/>
		</GBModalVScrollable>
	</GBRightPane>
</template>
<script>
import GBRightPane from './GBRightPane';
import GBModalVScrollable from './GBModalVScrollable';
import GBMemberListRowOuter from './GBMemberListRowOuter';
import {PERMISSION, FORM_MODE, VOID_FLAG} from '../data/Const';
import Notification from '../classes/Notification';
import DataSetManager from '../classes/DataSetManager';

import Util from '../classes/Util';

const MOVE_STATUS = {
	MOVE_START : 1,
	MOVE_END : 2,
};
const uuidv4 = require('uuid/v4');

export default {
	name: 'GBRightPaneMemberList',
	props: [
		"value",
		"isEditable",
	],
	components: {
		GBRightPane,
		GBModalVScrollable,
		GBMemberListRowOuter,
	},
	data: function() {
		return {
			move_state:MOVE_STATUS,
			event_target: null,
			filter_name: '',
			watchSlide: null,
			dataset_manager: this.$store.getters.datasetManager,
			selected_member: null,
		};
	},
	methods: {
		onClose: function() {
			this.filter_name = '';
			this.$store.dispatch('endExclusive');
			this.event_target = null;
			this.selected_member = null;
			this.$emit('close');
		},
		onScheduleListRowSlide: function(e) {
			this.watchSlide = {
				type: 'slide',
				target: e.target,
				status: e.status,
			};
		},
		InsertMemberRow: function(dest) {
			if (!this.event_target)
				return;
			this.MemberMoveTo(dest);
			this.$nextTick(() => {
				this.memberRowMoveEnd();
			});
		},
		InsertMemberRowTop: function() {
			if (!this.event_target)
				return;
			this.MemberMoveToTop();
			this.$nextTick(() => {
				this.memberRowMoveEnd();
			});
		},
		MemberMoveTo: function(dest){	
			this.$store.dispatch('memberMoveTo', {
				src_code: this.event_target.member.code,
				dst_code: dest.code,
			});
		},
		MemberMoveToTop: function(){
			this.$store.dispatch('memberMoveToTop', {
				src_code: this.event_target.member.code,
			});
		},
		onClick: function(e) {
			this.watchSlide = {
				type: 'click',
				target: e,
				status: null,
			};
		},
		onClickShowMemberInfo: function(e) {
			this.$emit("show-member-info", e);
		},
		
		memberRowMoveStart: function(e) {
			this.$store.dispatch('startExclusive');
			if (this.event_target || this.selected_member)
				return;
			this.event_target = {
				member : e.item,
				status : MOVE_STATUS.MOVE_START,
			}
			this.selected_member = {
				member: e.item,
			}
			this.$nextTick(() =>{
				this.$nextTick(() =>{
					let t = this.$refs.content.$el.getElementsByClassName('modal-content')[0];
					if (t){
						if((this.filtered_members.findIndex((m) => m.member === this.selected_member.member) != 0) && (t.scrollTop <= 0)){
								 t.scrollTop += 20;
						}
					}					
				});
			});
		},
		memberRowMoveEnd: function() {
			this.$store.dispatch('endExclusive');
			this.selected_member.status = MOVE_STATUS.MOVE_END;
			
			let t = this.$refs.content.$el.getElementsByClassName('modal-content')[0];
			
			if (t.scrollTop <= 20){
				t.scrollTop -= 20;
			}
			this.event_target = null;
			setTimeout(() => {	
				this.selected_member = null;
			}, 1200);
			
			if(!this.$store.getters.isUpdatedMemberList){
				return;
			}
			this.updateDataSet();
		},
		onClickAdd: function() {
			let duplicate = false;
			let login_id = "";
			do {
				let len = 6;
				let str = "abcdefghijklmnopqrstuvwxyz";
				let strLen = str.length;
				for (let i = 0; i < len; i++) {
					login_id += str[Math.floor(Math.random() * strLen)];
				}
				duplicate = this.$store.getters.isDuplicateLoginId(login_id);
			} while(duplicate);

			let newMember = {
				code: uuidv4(),
				login_id: login_id,
				login_password: login_id,
				permission: PERMISSION.ROLE.WORKER,
				name: '新しいメンバー',
				tel: '',
				remarks: '',
				classes: [],
				void: VOID_FLAG.VALID,
				is_updated: true,
			};
			this.$store.dispatch('addDataMember', newMember).then((res) => {
				if (res) {
					this.$nextTick(() => {
						let last_row = this.$refs.rows[this.$refs.rows.length - 1];
						last_row.$el.scrollIntoView(false);
					});
					this.$emit('update-dataset');
				} else {
					this.$store.commit('addNotification', Notification.error('メンバー追加に失敗しました', 'notificationCreateData'));
					return;
				}
			});
			let target = {member: newMember, mode: FORM_MODE.ENTRY};
			this.$emit("show-member-info", target);
		},
		onClickFiltering: function() {
			this.$emit('show-member-filtering', true);
			this.$forceUpdate();
		},
		updateDataSet: function() {
			const onFail = async (err) => {
				const callback = {
					401: () => {
						this.logout();
					},
				};
				Util.updateFail(this.$store, err.response, callback);
				
				this.fetchData();
			};
			const onTokenFail = () => {
				this.logout();
			};
			this.dataset_manager.setAfterDataset();
			this.dataset_manager.sync(null, onFail, onTokenFail);
		},
		fetchData: async function() {
			let access_token = await DataSetManager.confirmAccessToken(this.$store);
			await this.dataset_manager.fetch(access_token)
				.then((data) => {
					this.$store.commit('createData', data);
				})
				.catch(async (e) => {
					let notification = null;
					switch(e.response.status) {
					case 400:
						notification = Notification.error('リクエストに失敗しました', 'notificationCreateData');
						break;
					case 401:
						notification = Notification.error('もう一度ログインしてください', 'notificationCreateData');
						this.logout();
						break;
					case 403:
						notification = Notification.error('権限がありません', 'notificationCreateData');
						this.logout();
						break;
					case 404:
						notification = Notification.error('契約者情報の取得に失敗しました', 'notificationCreateData');
						break;
					case 500:
						notification = Notification.error('情報の取得に失敗しました', 'notificationCreateData');
						break;
					case 504:
						notification = Notification.error('タイムアウトしました', 'notificationCreateData');
						break;
					default :
						notification = Notification.error('通信に失敗しました', 'notificationCreateData');
						break;
					}
					this.$store.commit('addNotification', notification);
				});
		},
		logout: function() {
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		filtered_members: function() {
			let ret = this.$store.getters.filteredMemberList(this.$store.getters.memberList);
			return ret.filter((item) => {
				if (this.filter_name === null)
					return true;
				if (this.filter_name.length === 0)
					return true;
				return item.member.name.search(Util.replaceEscapeString(this.filter_name)) >= 0;
			});
		},
		isFiltering: function() {
			return this.$store.getters.isFilteringMemberList;
		},
	},

	mounted: function() {
		this.$refs.content.$el.addEventListener('click', this.onClick ,false);
	},
	beforeDestroy: function() {
		this.$refs.content.$el.removeEventListener('click', this.onClick ,false);
	},
	watch: {
		isEditable: function() {

		},
	},
}
</script>
<style>
	.modal-window.member-list .add-member {
		top: 0px;
		left: 0px;
	}
	.modal-window.member-list .modal-header-filter {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.member-list{
		background-color: #eee;
	}	
</style>
<style scoped >

</style>